import cartItem from 'assets/img/profil-do-tabliczki.png'
import type { DiscountsObject } from './utils/utils'
import { displayPrice } from 'utils/strings'
import React from 'react'

interface OrderItemProps extends order.Position {
  discounts?: DiscountsObject
  products?: order.CheckPriceProductObject
  setCart: React.Dispatch<React.SetStateAction<order.Cart>>
}

const OrderItem: React.FC<OrderItemProps> = ({ id, discounts, cartId, addons, profileName, products, setCart }) => {
  const product = products?.[id]
  const additionalProfileType = product?.order_params?.addons?.find(addon => addon.key === 'additional_profile')
  const additionalProfile = additionalProfileType ? (addons[additionalProfileType.id] || 0) : 0
  const cost = Number(product?.order_params?.cost)

  const addonsPrice = calculatePriceOfAddons(addons, product)
  const finalPrice = (cost - (((discounts?.[id]?.current || 0) / 100) * cost)) + addonsPrice
  const finalPriceWithoutDiscount = cost + calculatePriceOfAddons(addons, product)

  const removeItem = () => {
    setCart(prev => {
      return {
        ...prev,
        positions: prev.positions.filter(p => p.cartId !== cartId)
      }
    })
  }

  const updateItemAddon = (addonId: string, addonAmount: number) => {
    setCart(prev => {
      return {
        ...prev,
        positions: prev.positions.map(item => item.cartId === cartId
          ? { ...item, addons: { ...addons, [addonId]: addonAmount } }
          : item)
      }
    })
  }

  return (
    <div className='order__item'>
      <div className='order__item__row'>
        <img
          alt='cart_item'
          src={cartItem}
        />
        <div className='order__item__title --filled'>
          <div>{product?.product_name || 'Nazwa produktu'}</div>
          {profileName && <div>Opłacasz profil: {profileName}</div>}
        </div>
        <i
          className='icon icon--trash'
          onClick={removeItem}
        />
      </div>
      <div>
        {additionalProfileType && <p>Dodaj liczbę osób przypisanych do tabliczki</p>}
        <div className='order__item__row'>
          {additionalProfileType
            ? <div className='order__item__multiplier --filled'>
              <span
                className={`order__item__multiplier__button${!additionalProfile ? ' --disabled' : ''}`}
                onClick={() => {
                  if (additionalProfile > 0) {
                    updateItemAddon(additionalProfileType.id, additionalProfile - 1)
                  }
                }}>
                -
              </span>
              <span className='order__item__multiplier__number'>{(additionalProfile || 0) + 1}</span>
              <span
                className={`order__item__multiplier__button${additionalProfileType.max_items ? (additionalProfile >= additionalProfileType.max_items) : false ? ' --disabled' : ''}`}
                onClick={() => {
                  if (additionalProfileType.max_items ? additionalProfile < additionalProfileType.max_items : true) {
                    updateItemAddon(additionalProfileType.id, additionalProfile + 1)
                  }
                }}>
                +
              </span>
            </div>
            : <div className='--filled' />}
          <div className='order__item__price'>
            {finalPrice !== finalPriceWithoutDiscount && <span className='--oldPrice'>
              {displayPrice(finalPriceWithoutDiscount)}
            </span>}
            <span>{displayPrice(finalPrice)}</span>
          </div>
        </div>
      </div>
    </div >

  )
}

const calculatePriceOfAddons = (addons: order.PositionAddonObject, product?: order.CheckPriceProduct, discounts?: DiscountsObject) => {
  if (!product) return 0
  return Object.entries(addons).reduce((r, [id, amount]) => {
    let price = Number(product.order_params.addons.find(addon => addon.id === id)?.cost || 0)
    const discount = discounts?.[id]?.current
    if (discount) {
      price -= (discount / 100) * price
    }
    r += amount * price
    return r
  }, 0)
}

export default OrderItem